module.exports = __webpack_public_path__ + "static/wl_header_video_es-f3b037be67ad9afdaf4900026a707e34.mp4";